/**
 * The sponsors at the foot of every printed page of a stage's results.
 *
 * The sheet draws the strip once, at its end — which is where the on-screen
 * preview shows it. On paper these rules, handed to `printNode` (the print
 * document carries no other stylesheet), pin it to the bottom of each page:
 * a fixed element is repeated on every printed page, and the sheet's
 * `<tfoot>` spacer, repeated with it, keeps the last rows of each page from
 * running under the logos.
 *
 * Measured in Chrome's print-to-PDF: a negative `bottom` that would put the
 * strip in the page margin moves it to the top of the next page instead, so it
 * stays inside the page and takes room from the content.
 */

/** The strip of logos. */
export const SPONSORS_ATTR = 'data-print-sponsors';
/** The room kept free for it at the bottom of every page. */
export const SPONSORS_SPACE_ATTR = 'data-print-sponsors-space';

/** The strip's height on paper, logos and rule included. */
export const SPONSORS_HEIGHT = '14mm';

export const SPONSORS_PRINT_CSS =
  `[${SPONSORS_ATTR}] { position: fixed; left: 0; right: 0; bottom: 0; }` +
  `[${SPONSORS_SPACE_ATTR}] { height: calc(${SPONSORS_HEIGHT} + 4mm); }`;
